 export const calculateNpsScore = (values) => {
    if (!values || values.length < 2) return null;

    const sortedValues = [...values].sort((a, b) => a.value - b.value);

    const totalResponses = sortedValues.reduce((acc, val) => acc + val.count, 0);

    const promoters = sortedValues
        .filter((val) => val.value >= 9)
        .reduce((acc, val) => acc + val.count, 0);

    const detractors = sortedValues
        .filter((val) => val.value <= 6)
        .reduce((acc, val) => acc + val.count, 0);

    const nps = ((promoters - detractors) / totalResponses) * 100;

    return Math.round(nps);
};

 export const calculateNpsScoresByLabel = (data) => {
     if (!data || !data.length) return [];

     return data.map(({ label, values }) => {
         const totalResponses = values.reduce((acc, val) => acc + val.filter_count, 0);
         if (totalResponses === 0) {
             return {
                 label,
                 nps_score: 0,
             };
         }
         const promoters = values
             .filter((val) => val.value >= 9)
             .reduce((acc, val) => acc + val.filter_count, 0);

         const detractors = values
             .filter((val) => val.value <= 6)
             .reduce((acc, val) => acc + val.filter_count, 0);

         const npsScore = ((promoters - detractors) / totalResponses) * 100;

         return {
             label,
             nps_score: Math.round(npsScore),
         };
     });
 };
